// src/pages/MyAgentsPage.jsx
import React, { useState, useEffect, useCallback } from 'react';
// import { Link } from 'react-router-dom';
import AgentCard from '../components/agent/AgentCard'; 
import Button from '../components/common/Button';
import { useWallet } from '../contexts/WalletContext';
import { getAgentsForUser } from '../services/agentService';
import { PlusCircleIcon, UserGroupIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import Spinner from '../components/common/Spinner';
import CreateAgentModal from '../components/agent/CreateAgentModal'; 

const MyAgentsPage = () => {
  const { currentAccount } = useWallet();
  const [agents, setAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false); 

  const fetchAgents = useCallback(async () => {
    console.log("Fetching agents for current account:", currentAccount);
    if (currentAccount) {
      console.log("Fetching agents for account:", currentAccount);  
      setIsLoading(true);
      setError('');
      try {
        const userAgents = await getAgentsForUser(currentAccount);
        setAgents(userAgents);
      } catch (err) {
        console.error("Failed to fetch user agents:", err);
        setError(err.message || "Could not load your agents.");
      } finally {
        setIsLoading(false);
      }
    } else {
      setAgents([]);
      setError("Please connect your wallet to view your agents.");
    }
  }, [currentAccount]); 

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]); 

  const handleAgentCreated = () => {
    fetchAgents();
    // setIsCreateModalOpen(false); 
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 sm:mb-8 gap-4">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-100">My AI Agents</h1>
        {currentAccount && (
          <Button
            variant="primary" 
            onClick={() => setIsCreateModalOpen(true)}
            className="w-full sm:w-auto !py-2.5 text-sm sm:text-base bg-blue-500 hover:bg-blue-600 border-blue-500 hover:border-blue-600"
          >
            <PlusCircleIcon className="h-5 w-5 mr-2 inline-block" />
            Create New Agent
          </Button>
        )}
      </div>

      {isLoading && (
        <div className="flex justify-center py-10">
          <Spinner size="lg" color="blue" /> 
        </div>
      )}

      {!isLoading && error && (
        <div className={`text-center py-10 rounded-xl p-6 shadow-lg border
                         ${!currentAccount ? 'bg-yellow-900/30 backdrop-blur-sm border-yellow-700/50 text-yellow-300' 
                                           : 'bg-red-900/30 backdrop-blur-sm border-red-700/50 text-red-300'}`}>
          {!currentAccount ? (
            <InformationCircleIcon className="h-12 w-12 text-yellow-500 mx-auto mb-4" />
          ) : (
            <ExclamationTriangleIcon className="h-12 w-12 text-red-500 mx-auto mb-4" />
          )}
          <p className="text-xl font-semibold">{error}</p>
          {!currentAccount && <p className="mt-2 text-sm">Make sure your wallet is connected.</p>}
        </div>
      )}

      {!isLoading && !error && agents.length === 0 && currentAccount && (
         <div className="text-center py-16 bg-slate-800/50 backdrop-blur-md border border-slate-700/50 rounded-xl shadow-lg">
            <UserGroupIcon className="h-16 w-16 mx-auto text-slate-500 mb-4" />
            <p className="text-xl text-slate-300 mb-2">No Agents Found</p>
            <p className="text-sm text-slate-400 mb-6">You haven't created any AI agents yet.</p>
            <Button 
              variant="primary" 
              onClick={() => setIsCreateModalOpen(true)}
              className="bg-blue-500 hover:bg-blue-600 border-blue-500 hover:border-blue-600"
            >
                Create Your First Agent
            </Button>
        </div>
       )}

      {!isLoading && !error && agents.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {agents.map(agent => (
            <AgentCard key={agent.agent_id} agent={agent} />
          ))}
        </div>
      )}

    
      <CreateAgentModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onAgentCreated={handleAgentCreated}
      />
    </div>
  );
};

export default MyAgentsPage;